module.exports = __webpack_public_path__ + "img/terroir-moonlit-2-mobile.c1b55dad.jpg";